import { render, staticRenderFns } from "./PartGiftCardOrderItemList.vue?vue&type=template&id=400784de&"
import script from "./PartGiftCardOrderItemList.vue?vue&type=script&lang=js&"
export * from "./PartGiftCardOrderItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports